import { LayoutType } from "@formant/core/model/LayoutType";
import { SetSelectedDateAction } from "@formant/rectangle-sdk/src/enums/selected-date.enum";

import { Mode } from "../../model/Mode";

export interface ICarriedOverTime {
    time: Date;
    isPlaying: boolean;
}

export interface IRectangleStoreStateForTimeCarryOver {
    setSelectedDate: (action: SetSelectedDateAction, arg: Date) => void;
    setIsLive: (arg: boolean) => void;
    setIsPlaying: (arg: boolean) => void;
}

/**
 * v1 views keep their timeline in ObserveStore, Coherence views keep it in the
 * rectangle-sdk store. When switching from a v1 view that is not live to a
 * Coherence view, return the v1 time so the Coherence timeline can start there.
 */
export function getV1TimeToCarryOver(
    previousLayoutType: LayoutType,
    nextLayoutType: LayoutType,
    observe: { mode: Mode; time: Date },
): ICarriedOverTime | undefined {
    if (previousLayoutType !== "observe" || nextLayoutType !== "dashboard") {
        return undefined;
    }
    if (observe.mode === "live" || isNaN(observe.time.getTime())) {
        return undefined;
    }
    return {
        time: new Date(observe.time.getTime()),
        isPlaying: observe.mode === "play",
    };
}

export function applyCarriedOverTime(
    carried: ICarriedOverTime,
    state: IRectangleStoreStateForTimeCarryOver,
) {
    state.setIsLive(false);
    state.setIsPlaying(carried.isPlaying);
    state.setSelectedDate(SetSelectedDateAction.Default, carried.time);
}
